export default __webpack_public_path__ + "static/media/banner2.612138f6.jpg";